import { types } from '../reducers/originOutputsReducer';

// eslint-disable-next-line import/prefer-default-export
export const createOriginOutputs = (values) => ({
  type: types.POST,
  payload: values,
});

export const updateOriginOutputs = (values) => ({
  type: types.PUT,
  payload: values,
});

export const removeOriginOutputs = (item) => ({
  type: types.DELETE,
  payload: item,
});

export const reloadOriginOutputs = (items) => ({
  type: types.RELOAD,
  payload: items,
});


export const resetOriginOutputs = () => ({
  type: types.RESET,
});


export { getDraftId } from '../reducers/originOutputsReducer';
